import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {Link} from 'react-router-dom'
import {NullAsDefault} from 'views/Shared'
import _ from "lodash";
import {renderIf} from "../../Shared";
import {ItemInformation} from "../../AppLocals/Organization/OrganizationEntity";
import {formatDate, renderFromToTime} from "../../../helpers/datetimeHelpers";
import {DoubleValueItem} from "../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";


export const renderExamination = ({renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {
        owner,
        status,
        timelimit,
        time_open,
        time_close,
    } = item ?? {}

    return (
        <Translate key={index}>
            {(t) => (
                <div
                    className="py-3 flex flex-col gap-2 rounded-lg custom-item-render custom-render-border relative"> {/* Sửa py-2 -> py-3, gap-1 -> gap-2 */}
                    <Link
                        to={getLinkToDetail(item)}
                        className="font-bold text-xl text-color-000 no-underline"> {/* Tăng text-lg -> text-xl */}
                        {getTitle(item)}
                    </Link>
                    <ItemInformation
                        showIcon={true}
                        label="time takes place"
                        value={renderFromToTime(time_open, time_close)}
                        className="text-sm italic" // Tăng text-xs -> text-sm
                    />
                    <ItemInformation
                        showIcon={true}
                        label={t('time for work')}
                        value={`${timelimit} ${t('minutes')}`}
                        className="text-sm italic" // Tăng text-xs -> text-sm
                    />
                    <div className="absolute right-5 top-5 contextIcon">
                        {renderContextMenu(item)}
                    </div>
                </div>
            )}
        </Translate>
    )
}


export const renderExaminationCompact =
    ({renderContextMenu = NullAsDefault} = {}) =>
        (item, index) => {
            const {time_open, time_close, owner} = item ?? {}

            return (
                <Translate key={index}>
                    {(t) => (
                        <div className="px-3 py-2 background border border-color-50 shadow-md hover:scale-2xs rounded-xl custom-item-render relative">
                            <div className="flex flex-col">
                                <Link
                                    to={getLinkToDetail(item)}
                                    className="mb-1 font-bold text-base text-color-000 no-underline leading-tight truncate">
                                    {getTitle(item)}
                                </Link>

                                <ItemInformation
                                    showIcon={true} label="organization by"
                                    className="text-xs italic truncate"
                                    value={
                                        <Link to={getLinkToDetail(owner)}
                                              className="flex-1 font-medium text-blue-500 no-underline">
                                            {getTitle(owner)}
                                        </Link>
                                    }
                                />
                                {renderIf(
                                    _.some([time_open, time_close]),
                                    <DoubleValueItem
                                        showIcon={true}
                                        labelFirst="from date"
                                        valueFirst={formatDate(time_open, 'DD/MM/YYYY')}
                                        labelSecond={time_close && ' - ' || ''}
                                        valueSecond={time_close && formatDate(time_close, 'DD/MM/YYYY')}
                                        className="text-xs italic truncate" // Tăng text-xs -> text-sm
                                    />
                                )}
                            </div>
                            {_.isFunction(renderContextMenu) && (
                                <div className="absolute right-5 top-5 contextIcon">
                                    {renderContextMenu(item)}
                                </div>
                            )}
                        </div>
                    )}
                </Translate>
            )
        }